module.exports = __webpack_public_path__ + "img/category-card-bg-3.cf5d155f.png";